export default __webpack_public_path__ + "static/media/SWT0360.34I-27871_-16745_0.ee0c1d49.jpg";